import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=fc23bbcc&scoped=true&"
import script from "./Article.vue?vue&type=script&lang=js&"
export * from "./Article.vue?vue&type=script&lang=js&"
import style0 from "./Article.vue?vue&type=style&index=0&id=fc23bbcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc23bbcc",
  null
  
)

export default component.exports